// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.1_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.1_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.gitadmin-status-dot {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 999px;
}

.gitadmin-status-dot-success {
  background-color: #198754;
}

.gitadmin-status-dot-failed {
  background-color: #dc3545;
}

.gitadmin-status-dot-default {
  background-color: #6c757d;
}

.gitadmin-time-progress {
  min-width: 160px;
}

.gitadmin-issues-filter-select {
  width: 170px;
}

.gitadmin-toggle-icon-slot {
  width: 18px;
}

.gitadmin-coverage-pie {
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
}

.gitadmin-coverage-track,
.gitadmin-coverage-value {
  fill: none;
  stroke-width: 4;
  transform-origin: 50% 50%;
  transform: rotate(-90deg);
}

.gitadmin-coverage-track {
  stroke: #dee2e6;
}

.gitadmin-coverage-value {
  stroke: #0d6efd;
  stroke-linecap: round;
}

.gitadmin-coverage-value-low {
  stroke: #dc3545;
}

.gitadmin-coverage-value-ok {
  stroke: #198754;
}

.gitadmin-timeline-chart-control {
  background-color: #f8f9fa;
}

.gitadmin-timeline-svg {
  display: block;
}

.gitadmin-timeline-grid-line {
  stroke: #adb5bd;
  stroke-width: 0.6;
  stroke-dasharray: 2 2;
}

.gitadmin-timeline-axis-line {
  stroke: #495057;
  stroke-width: 1;
}

.gitadmin-timeline-axis-text,
.gitadmin-timeline-caption {
  color: #212529;
  fill: #212529;
}

.gitadmin-timeline-estimate-path {
  fill: none;
  stroke: #0d6efd;
  stroke-dasharray: 3 2;
  stroke-width: 2;
}

.gitadmin-timeline-spent-path {
  fill: none;
  stroke: #198754;
  stroke-width: 2;
}

.gitadmin-debug-pre {
  max-height: 280px;
  overflow: auto;
}

.gitadmin-workload-chart {
  border: 1px solid #e9ecef;
  border-radius: 0.75rem;
  padding: 0.9rem;
  background: linear-gradient(180deg, #fbfdff 0%, #f8f9fa 100%);
}

.gitadmin-workload-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 0.75rem;
  font-size: 0.85rem;
  color: #495057;
}

.gitadmin-workload-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.gitadmin-workload-swatch {
  width: 12px;
  height: 12px;
  border-radius: 999px;
  display: inline-block;
}

.gitadmin-workload-swatch-estimate {
  background-color: #0d6efd;
}

.gitadmin-workload-swatch-spent {
  background-color: #198754;
}

.gitadmin-workload-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.gitadmin-workload-row {
  display: grid;
  grid-template-columns: minmax(140px, 220px) minmax(220px, 1fr) minmax(130px, 170px);
  gap: 0.75rem;
  align-items: center;
}

.gitadmin-workload-user-name {
  font-weight: 600;
  color: #212529;
  line-height: 1.2;
}

.gitadmin-workload-user-meta {
  font-size: 0.78rem;
  color: #6c757d;
}

.gitadmin-workload-bars {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.gitadmin-workload-track {
  width: 100%;
  height: 14px;
  border-radius: 999px;
  background-color: #edf1f4;
  overflow: hidden;
  position: relative;
}

.gitadmin-workload-bar {
  height: 100%;
  min-width: 2px;
  border-radius: 999px;
}

.gitadmin-workload-bar-estimate {
  background: linear-gradient(90deg, #0d6efd, #3f8cff);
}

.gitadmin-workload-bar-spent {
  background: linear-gradient(90deg, #198754, #36b36f);
}

.gitadmin-workload-reference-marker {
  position: absolute;
  top: -1px;
  bottom: -1px;
  width: 2px;
  margin-left: -1px;
  background-color: #212529;
  opacity: 0.75;
  pointer-events: none;
}

.gitadmin-workload-values {
  font-size: 0.8rem;
  color: #495057;
  text-align: right;
}

@media (max-width: 991.98px) {
  .gitadmin-workload-row {
    grid-template-columns: 1fr;
    gap: 0.45rem;
  }

  .gitadmin-workload-values {
    text-align: left;
    display: flex;
    gap: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mFAAmF;EACnF,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,YAAY;EACd;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.gitadmin-status-dot {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 999px;\n}\n\n.gitadmin-status-dot-success {\n  background-color: #198754;\n}\n\n.gitadmin-status-dot-failed {\n  background-color: #dc3545;\n}\n\n.gitadmin-status-dot-default {\n  background-color: #6c757d;\n}\n\n.gitadmin-time-progress {\n  min-width: 160px;\n}\n\n.gitadmin-issues-filter-select {\n  width: 170px;\n}\n\n.gitadmin-toggle-icon-slot {\n  width: 18px;\n}\n\n.gitadmin-coverage-pie {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.gitadmin-coverage-track,\n.gitadmin-coverage-value {\n  fill: none;\n  stroke-width: 4;\n  transform-origin: 50% 50%;\n  transform: rotate(-90deg);\n}\n\n.gitadmin-coverage-track {\n  stroke: #dee2e6;\n}\n\n.gitadmin-coverage-value {\n  stroke: #0d6efd;\n  stroke-linecap: round;\n}\n\n.gitadmin-coverage-value-low {\n  stroke: #dc3545;\n}\n\n.gitadmin-coverage-value-ok {\n  stroke: #198754;\n}\n\n.gitadmin-timeline-chart-control {\n  background-color: #f8f9fa;\n}\n\n.gitadmin-timeline-svg {\n  display: block;\n}\n\n.gitadmin-timeline-grid-line {\n  stroke: #adb5bd;\n  stroke-width: 0.6;\n  stroke-dasharray: 2 2;\n}\n\n.gitadmin-timeline-axis-line {\n  stroke: #495057;\n  stroke-width: 1;\n}\n\n.gitadmin-timeline-axis-text,\n.gitadmin-timeline-caption {\n  color: #212529;\n  fill: #212529;\n}\n\n.gitadmin-timeline-estimate-path {\n  fill: none;\n  stroke: #0d6efd;\n  stroke-dasharray: 3 2;\n  stroke-width: 2;\n}\n\n.gitadmin-timeline-spent-path {\n  fill: none;\n  stroke: #198754;\n  stroke-width: 2;\n}\n\n.gitadmin-debug-pre {\n  max-height: 280px;\n  overflow: auto;\n}\n\n.gitadmin-workload-chart {\n  border: 1px solid #e9ecef;\n  border-radius: 0.75rem;\n  padding: 0.9rem;\n  background: linear-gradient(180deg, #fbfdff 0%, #f8f9fa 100%);\n}\n\n.gitadmin-workload-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 0.75rem;\n  font-size: 0.85rem;\n  color: #495057;\n}\n\n.gitadmin-workload-legend-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.gitadmin-workload-swatch {\n  width: 12px;\n  height: 12px;\n  border-radius: 999px;\n  display: inline-block;\n}\n\n.gitadmin-workload-swatch-estimate {\n  background-color: #0d6efd;\n}\n\n.gitadmin-workload-swatch-spent {\n  background-color: #198754;\n}\n\n.gitadmin-workload-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.gitadmin-workload-row {\n  display: grid;\n  grid-template-columns: minmax(140px, 220px) minmax(220px, 1fr) minmax(130px, 170px);\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.gitadmin-workload-user-name {\n  font-weight: 600;\n  color: #212529;\n  line-height: 1.2;\n}\n\n.gitadmin-workload-user-meta {\n  font-size: 0.78rem;\n  color: #6c757d;\n}\n\n.gitadmin-workload-bars {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.gitadmin-workload-track {\n  width: 100%;\n  height: 14px;\n  border-radius: 999px;\n  background-color: #edf1f4;\n  overflow: hidden;\n  position: relative;\n}\n\n.gitadmin-workload-bar {\n  height: 100%;\n  min-width: 2px;\n  border-radius: 999px;\n}\n\n.gitadmin-workload-bar-estimate {\n  background: linear-gradient(90deg, #0d6efd, #3f8cff);\n}\n\n.gitadmin-workload-bar-spent {\n  background: linear-gradient(90deg, #198754, #36b36f);\n}\n\n.gitadmin-workload-reference-marker {\n  position: absolute;\n  top: -1px;\n  bottom: -1px;\n  width: 2px;\n  margin-left: -1px;\n  background-color: #212529;\n  opacity: 0.75;\n  pointer-events: none;\n}\n\n.gitadmin-workload-values {\n  font-size: 0.8rem;\n  color: #495057;\n  text-align: right;\n}\n\n@media (max-width: 991.98px) {\n  .gitadmin-workload-row {\n    grid-template-columns: 1fr;\n    gap: 0.45rem;\n  }\n\n  .gitadmin-workload-values {\n    text-align: left;\n    display: flex;\n    gap: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
